import { Inject, Injectable } from '@angular/core';
import { HttpResponse } from '@angular/common/http';
import { isNil, omit } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

import { $frontendTypes } from './Returns.frontend.types'

@Injectable({ providedIn: 'root' })
export class Returns_create_return_order_from_outbound_flowService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  async run(inParams: { outboundOrderId: number, inboundOrder?: { lookupcode?: string, requestedDeliveryDate?: string, ownerReference?: string, warehouseId?: number } }): Promise<{ warehouseTransferId?: number, outboundOrderId?: number, inboundOrderId?: number, outboundShipmentId?: number, inboundShipmentId?: number, reasons?: string[] }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.outboundOrderId)) {
      missingRequiredInParams.push('\'outboundOrderId\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/Returns/functions/create_return_order_from_outbound_flow`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }

}

